import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useGetRequest } from 'hooks';

import { SnapDetails } from 'codegen';

import { initSnapSuccessAction, snapStore } from '../store';

export const useSnapDetails = () => {
  const refetchSnapData = snapStore((state) => state.refetchSnapData);

  const { snapId } = useParams();

  const { loading, refresh } = useGetRequest<SnapDetails>({
    url: '/snaps/details',
    queryParams: { id: snapId },
    options: {
      onSuccess: ({ data }) => initSnapSuccessAction(data),
      refreshDeps: [snapId],
    },
  });

  useEffect(() => {
    if (refetchSnapData) {
      refresh();
    }
  }, [refetchSnapData]);

  return { loading };
};
